// gulpfile.js
(function() {

	var setCookie = function setCookie(cookieObj) {
		var defaultPath = '/';
		var hostname = window.location.hostname;
		var domainOnly = hostname.replace(/www\.|stg\./g, '');
		var defaultDomain = domainOnly === hostname ? domainOnly : '.' + domainOnly;

		for (var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		  otherArgs[_key - 1] = arguments[_key];
		}

		if (!Array.isArray(cookieObj) && _typeof(cookieObj) === 'object') {
		  if (otherArgs.length) {
		    var path = otherArgs[0],
		        domain = otherArgs[1],
		        expires = otherArgs[2];
		    path = path || defaultPath;
		    domain = domain || defaultDomain;
		    Object.keys(cookieObj).forEach(function (cookieName) {
		      document.cookie = "".concat(cookieName, "=").concat(cookieObj[cookieName], ";path=").concat(path, ";domain=").concat(domain, ";Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
		      document.cookie = "".concat(cookieName, "=").concat(cookieObj[cookieName], ";path=").concat(path, ";domain=").concat(domain, ";") + (expires ? "Expires=".concat(expires, ";") : '');
		    });
		  } else {
		    Object.keys(cookieObj).forEach(function (cookieName) {
		      var value = '';
		      var path = defaultPath;
		      var domain = defaultDomain;
		      var expires = '';

		      if (_typeof(cookieObj[cookieName]) === 'object') {
		        value = cookieObj[cookieName]['value'] || '';
		        path = cookieObj[cookieName]['path'] || path;
		        domain = cookieObj[cookieName]['domain'] || domain;
		        expires = cookieObj[cookieName]['expires'] || '';
		      } else {
		        value = cookieObj[cookieName];
		      }

		      document.cookie = "".concat(cookieName, "=").concat(value, ";path=").concat(path, ";domain=").concat(domain, ";Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
		      document.cookie = "".concat(cookieName, "=").concat(value, ";path=").concat(path, ";domain=").concat(domain, ";") + (expires ? "Expires=".concat(expires, ";") : '');
		    });
		  }
		} else if (typeof cookieObj === 'string') {
		  if (otherArgs && otherArgs.length) {
		    var key = cookieObj;
		    var _value = otherArgs[0],
		        _path = otherArgs[1],
		        _domain = otherArgs[2],
		        _expires = otherArgs[3];
		    _path = _path || defaultPath;
		    _domain = _domain || defaultDomain;
		    document.cookie = "".concat(key, "=").concat(_value, ";path=").concat(_path, ";domain=").concat(_domain, ";Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
		    document.cookie = "".concat(key, "=").concat(_value, ";path=").concat(_path, ";domain=").concat(_domain, ";") + (_expires ? "Expires=".concat(_expires, ";") : '');
		  } else {
		    window.debugLog('Error', 'The cookie value must be supplied as the second parameter', value, 'setCookie');
		    return false;
		  }
		} else {
		  window.debugLog('Error', "First parameter must be of type \"object\" or \"string\" - First parameter given is of type: \"".concat(_typeof(cookieObj), "\"."), cookieObj, 'setCookie');
		  return false;
		}

		window.debugLog('Info', 'Cookies were set.', document.cookie, 'setCookie');
		return true;
	};

	var acePul = '/ace-pul/';

	$('#ace-pul').modal('show')

	$.when(window.defTrackingInformation).done(function(trackingInfo) {
	    if (window.location.pathname === acePul) {
	    	setCookie({
	    		'800LMLandingPage': encodeURI('Source=' + window.acePulSource + '&SourceLocation=' + window.acePulSourceLocation + '&StoreNumber=' + window.acePulStoreNumber + '&StoreKey=' + window.acePulStoreKey)
	    	});

	        window.location.href = globalSiteSettings.www2Url + 'personal-loans/personal-loan-application';
	    }
	})

})();

